import AgTechMetric from '@agtech/web/components/Metrics/AgTechMetric';
import AgTechNoRecordsPage from '@agtech/web/components/Pages/Error/AgTechNoRecordsPage';
import React from 'react'
import BidderRegisteredBiddersGrid from './components/grids/BidderRegisteredBiddersGrid';
import BidderSelectionViewDialog from './dialogs/BidderSelectionViewDialog';
import { SaleBiddersDataProvider } from '@sales/data/bidders/BidderDataQueries';
import { IndexLength } from '@agtech/core/utilities/AgTechUtilities';

const SaleManageBiddersPage = () => {
    return (
        <SaleBiddersDataProvider>
            {(bidderData) => {
                const bidders = Object.values(bidderData.bidders);

                return bidders.length > 0 ? (
                    <div className='stretched column-based flex'>
                        <div id='sale-bidders-grid' className='flexed pr-4 flex'>
                            <BidderRegisteredBiddersGrid />
                        </div>
                        <div className='w-[240px] row-based tall pl-4 flex'>
                            <div id='sale-bidders-count-metric'>
                                <AgTechMetric
                                    header='Registered Bidders'
                                    value={bidders.length.toString()}
                                />
                            </div>
                            <div id='sale-bidders-register-btn' className='mt-auto'>
                                <BidderSelectionViewDialog.Button
                                    classes='button-block button-highlight w-full'
                                />
                            </div>
                        </div>
                    </div>
                )
                : (
                    <AgTechNoRecordsPage
                        message="There are currently no bidders registered for this sale."
                        action={{
                            prompt: 'To register bidders, please click the button below',
                            button: () => (
                                <BidderSelectionViewDialog.Button
                                    text='Register Bidders'
                                    classes='button-highlight'
                                />
                            )
                        }}
                    />
                )
            }}
        </SaleBiddersDataProvider>
    );
}

export default SaleManageBiddersPage;
